import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { changePassword } from '../../../actions/settings/changePassword';
import CloseIcon from '../../../assets/images/common/modals/close.svg';
import { logoutUserLocally } from '../../../actions/login/logout';
import { miscLinks } from '../../../utils/internalLinks';

const texts = {
    title: 'Change Password',
    current_password: 'Current Password',
    password: 'New Password',
    password_confirmation: 'Confirm Password',
    matchingError: 'Passwords should be matching.',
    errorMsg: 'Please enter new password.'
}

class ChangePasswordModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current_password: '',
            password: '',
            password_confirmation: '',
            matchingError: false,
            disabledSubmit: false,
            error: false,
            errorMsg: ''
        }
        this._handleInputChange = this._handleInputChange.bind(this);
        this._handleNewPasswordUpdate = this._handleNewPasswordUpdate.bind(this);
        this._toggleDisableSubmit = this._toggleDisableSubmit.bind(this);
    }

    _handleInputChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    _toggleDisableSubmit(disabled) {
        this.setState({
            disabledSubmit: typeof disabled !== 'undefined'
                ? disabled
                : !this.state.disabledSubmit
        })
    }

    _handleNewPasswordUpdate(e) {
        e.preventDefault();
        this.setState({
            matchingError: false,
            error: false
        })
        const { current_password,
            password,
            password_confirmation,
            disabledSubmit
        } = this.state;
        if (!current_password
            || !password
            || !password_confirmation
            || disabledSubmit) return;
        if (password !== password_confirmation) {
            this.setState({
                matchingError: true
            });
            return;
        }
        const { changePassword,
            token,
            logoutUserLocally,
            onClose } = this.props;
        let dataToSend = {
            current_password,
            password,
            password_confirmation
        }
        this._toggleDisableSubmit(true);
        changePassword(dataToSend, token)
            .then(val => {
                this._toggleDisableSubmit(false);
                if (val) {
                    // onClose();
                    logoutUserLocally();
                    window.location.href = miscLinks.home;
                } else {
                    this.setState({
                        error: true
                    })
                }
            })
    }

    render() {
        const { onClose } = this.props,
            { current_password,
                password,
                password_confirmation,
                matchingError,
                error,
                disabledSubmit } = this.state,
            isDisabled = ((current_password.trim().length < 6)
                || password.trim().length < 6
                || password_confirmation.trim().length < 6);
        return (<>
            <div className="default-modal__header">
                <p className="default-modal__header__title">{texts.title}</p>
                <button className="default-modal__header__close" onClick={() => {
                    if (disabledSubmit) return;
                    onClose();
                }}>
                    <img src={CloseIcon} alt="close modal" />
                </button>
            </div>
            <div className="default-modal__content">
                <form onSubmit={this._handleNewPasswordUpdate}>
                    <div className="profile-form-modals__form">
                        <div className="profile-form-modals__form__group">
                            <input type="password"
                                name="current_password"
                                value={current_password}
                                autoFocus={true}
                                onChange={this._handleInputChange}
                                className="profile-form-modals__input"
                                required
                                placeholder={texts.current_password} />
                        </div>
                        <div className="profile-form-modals__form__group">
                            <input type="password"
                                name="password"
                                value={password}
                                onChange={this._handleInputChange}
                                required
                                className="profile-form-modals__input"
                                placeholder={texts.password} />
                        </div>
                        <div className="profile-form-modals__form__group">
                            <input type="password"
                                name="password_confirmation"
                                value={password_confirmation}
                                onChange={this._handleInputChange}
                                required
                                className="profile-form-modals__input"
                                placeholder={texts.password_confirmation} />
                                { matchingError && <p className="error-text">{texts.matchingError}</p> }
                                { error && <p className="error-text">{texts.errorMsg}</p> }
                        </div>
                    </div>
                    <div className="profile-form-modals__footer profile-form-modals__footer--right">
                        <button type="submit"
                            disabled={isDisabled || disabledSubmit}
                            className={`profile-form-modals__btn
                            ${(isDisabled || disabledSubmit)
                                ? 'profile-form-modals__btn--disabled'
                                : ''}`}>Change</button>
                    </div>
                </form>
            </div>
        </>);
    }
}

function mapStateToProps(state) {
    return {
        token: state.login.token
    }
}

const mapDispatchToProps = {
    changePassword,
    logoutUserLocally
}

ChangePasswordModal.propTypes = {
    onClose: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordModal);